import React from 'react';
import BaseCell from './BaseCell';

const MultiTextCell = ({ hasTooltip, items, ...props }) => {
  const text = items ? items.join(', ') : '';
  return (
    <BaseCell title={hasTooltip ? text : null} {...props}>
      {text}
    </BaseCell>
  );
};

export default MultiTextCell;
